import * as React from 'react'
import { useEffect } from 'react';
import { apiConstants, get, patchGeneric, post, postGeneric } from '../../common/constants'
import { Card, CardContent, Grid, Button, Box, Chip, Menu, MenuItem, ListItemIcon, ListItemText, Divider, alpha } from '@mui/material';
import { useLocation, Link } from 'react-router-dom';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ProzoDataGrid from '../../common/ProzoDataGrid';
import { useState } from 'react';
import { FormProvider, RHFSelectField, RHFTextField } from '../../common/hook-form';
import { CourierFilter } from '../../common/ProshipFormComponents';
import { LoadingButton } from '@mui/lab';
import { useFieldArray, useForm } from 'react-hook-form';
import PageTitle from '../../components/PageTitle';
import Loader from '../../common/Loader';
import { useSnackbar } from 'notistack';
import MUIModal from "../../components/MuiModal";
import { designationB2c } from "../../common/util";
import _ from "lodash";
import AddCourier from './AddCourier';
import AddIcon from '@mui/icons-material/Add';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditIcon from '@mui/icons-material/Edit';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import SideDrawer from '../../components/SideDrawer';
import { FieldLabel, FilterField } from '../../common/FilterBar';

// Row actions menu — mirrors the B2B tab exactly: an outlined "Actions" button with a ⋮ icon.
function ActionMenu({ row, active, onEdit, onToggle }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (e) => setAnchorEl(e.currentTarget);
    const handleClose = () => setAnchorEl(null);
    const menuAction = (fn) => () => { handleClose(); fn(); };
    return (
        <>
            <Button size="small" variant="contained" disableElevation onClick={handleClick} endIcon={<MoreVertIcon />}
                sx={{ textTransform: 'none', fontWeight: 600, bgcolor: '#e3f2fd', color: '#1565c0', boxShadow: 'none', '&:hover': { bgcolor: '#1565c0', color: '#fff', boxShadow: 'none' } }}>
                Actions
            </Button>
            <Menu
                anchorEl={anchorEl} open={open} onClose={handleClose}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                PaperProps={{ elevation: 8, sx: { minWidth: 230, borderRadius: 2, mt: 0.5, py: 0.5, border: '1px solid', borderColor: 'divider' } }}
            >
                <MenuItem onClick={menuAction(onEdit)} sx={{ mx: 1, borderRadius: 1, py: 0.8, '&:hover': { bgcolor: (t) => alpha(t.palette.primary.main, 0.08) } }}>
                    <ListItemIcon><EditIcon fontSize="small" sx={{ color: 'primary.main' }} /></ListItemIcon>
                    <ListItemText primaryTypographyProps={{ variant: 'body2', fontWeight: 500 }}>Edit Courier</ListItemText>
                </MenuItem>
                <MenuItem component={Link} to={`/courier/setup/${row.id}`} onClick={handleClose} sx={{ mx: 1, borderRadius: 1, py: 0.8, color: 'inherit', textDecoration: 'none', '&:hover': { bgcolor: (t) => alpha(t.palette.primary.main, 0.08) } }}>
                    <ListItemIcon><SettingsSuggestIcon fontSize="small" sx={{ color: 'primary.main' }} /></ListItemIcon>
                    <ListItemText primaryTypographyProps={{ variant: 'body2', fontWeight: 500 }}>Recommendation Rules</ListItemText>
                </MenuItem>
                <Divider sx={{ my: 0.5, mx: 1.5 }} />
                <MenuItem onClick={menuAction(onToggle)} sx={{ mx: 1, borderRadius: 1, py: 0.8, '&:hover': { bgcolor: (t) => alpha((active ? t.palette.error.main : t.palette.success.main), 0.08) } }}>
                    <ListItemIcon><PowerSettingsNewIcon fontSize="small" sx={{ color: active ? 'error.main' : 'success.main' }} /></ListItemIcon>
                    <ListItemText primaryTypographyProps={{ variant: 'body2', fontWeight: 500 }}>{active ? 'Disable Courier' : 'Enable Courier'}</ListItemText>
                </MenuItem>
            </Menu>
        </>
    );
}

// Rich table cells — mirrors the D2C Forward Shipment table (UnprocessedOrdersForward.js).
const CellLine = ({ children, muted, bold, ellipsis }) => (
    <Box sx={{
        fontSize: 12.5, lineHeight: 1.4,
        color: muted ? 'text.secondary' : 'text.primary',
        fontWeight: bold ? 600 : 400,
        ...(ellipsis
            ? { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }
            : { whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'anywhere' }),
    }}>{children}</Box>
);
const CellStack = ({ children }) => (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.35, width: '100%', py: 0.5 }}>{children}</Box>
);
const gridSx = {
    '& .MuiDataGrid-columnHeaders': { backgroundColor: '#F9FAFB', borderBottom: '1px solid #E2E8F0' },
    '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 700, color: '#475569' },
    '& .MuiDataGrid-cell': { paddingTop: '12px', paddingBottom: '12px' },
};


export default function B2CCouriers() {
    const { search } = useLocation()
    const queryParams = React.useMemo(() => new URLSearchParams(search), [search])
    const [page, setPage] = useState(0);
    const [sizePerPage, setSizePerPage] = useState(20);
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [filter, setFilter] = useState()
    const [courierFilter, setCourierFilter] = useState(null)
    const [tabList, setTabList] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [addOpen, setAddOpen] = useState(false);
    const [isEditData, setIsEditData] = useState(null);
    const [reload, setReload] = useState(0);
    const [val, setVal] = useState();
    // const { enqueueSnackbar } = useSnackbar();

    const methods = useForm({
        defaultValues: {
            courier: ''
        }
    })
    const { handleSubmit, reset } = methods;

    const onSubmit = async (data) => {
        setIsSubmitting(true)
        setFilter(data.courier)
        setIsSubmitting(false)
    }

    const handleCourierToggle = (id, parent, isActive) => {
        let payload = {
            id: id,
            parent: parent,
            isActive: isActive === undefined || isActive === true ? false : true
        }
        patchGeneric(apiConstants.COURIERS, payload).then((res) => {
            setReload(reload + 1)
        }).catch((err) => console.log(err))
    }

    const Columns = [
        {
            field: 'parent', headerName: 'Courier', flex: 1.2, sortable: false, align: 'left',
            renderCell: (col) => (
                <CellStack>
                    <CellLine bold>{col.row?.parent || '—'}</CellLine>
                    {col.row?.cpAccountCode && <CellLine muted ellipsis>{col.row.cpAccountCode}</CellLine>}
                </CellStack>
            ),
        },
        {
            field: 'prozoId', headerName: 'Prozo Courier ID', flex: 1, sortable: false, align: 'left',
            renderCell: (col) => <CellLine muted>{col.row?.prozoId || '—'}</CellLine>,
        },
        {
            field: 'email', headerName: 'Email', flex: 1, sortable: false, align: 'left',
            renderCell: (col) => <CellLine muted>{col.row?.email || '—'}</CellLine>,
        },
        {
            field: 'kamDetails', headerName: 'Personnel', flex: 0.7, sortable: false, align: 'left',
            renderCell: (col) => (
                <Button startIcon={<AddCircleIcon />} size='small' variant='outlined' sx={{ textTransform: 'none' }} onClick={() => { handleOpen(col.row) }}>KAM</Button>
            ),
        },
        {
            field: 'status', headerName: 'Status', flex: 0.6, sortable: false, align: 'center', headerAlign: 'center',
            renderCell: (col) => {
                const active = col.row?.isActive === undefined || col.row?.isActive === true
                return <Chip size='small' label={active ? 'Active' : 'Inactive'} sx={{ fontWeight: 600, fontSize: 11, bgcolor: active ? '#e8f5e9' : '#f1f5f9', color: active ? '#16a34a' : '#64748b' }} />
            },
        },
        {
            field: 'action', headerName: 'Actions', flex: 0.7, sortable: false, align: 'center', headerAlign: 'center',
            renderCell: (col) => {
                const active = col.row?.isActive === undefined || col.row?.isActive === true
                return (
                    <ActionMenu
                        row={col.row}
                        active={active}
                        onEdit={() => { setAddOpen(true); setIsEditData(col.row) }}
                        onToggle={() => handleCourierToggle(col.row.id, col.row.parent, col.row.isActive)}
                    />
                )
            },
        },
    ]

    useEffect(() => {
        setIsLoading(true)
        let pageNo = parseInt(queryParams.get('page')) || page
        let limit = parseInt(queryParams.get('limit')) || sizePerPage
        if (filter) {
            get(`${apiConstants.COURIERS}/${filter}`).then((res) => {
                setCourierFilter([res?.data?.result])
                setIsLoading(false)
            }).catch((err) => {
                console.log(err);
                setIsLoading(false)
            })
        }
        else {
            const andfilter = [{
                "field": "supported_shipment",
                "operator": "eq",
                "value": "B2C"
            }]
            post(apiConstants.COURIER_PARTNER_SEARCH, {
                "offset": pageNo * limit,
                "limit": limit,
                andfilter: andfilter

            }).then((res) => {
                setIsLoading(false)
                // setData(res?.data?.data);
                const data = res?.data?.data.filter((val) => val.supported_shipment === "B2C")
                setTabList(data)
            })
                .catch(err => {
                    console.log(err)
                    setIsLoading(false)
                })
        }
    }, [sizePerPage, page, filter, queryParams, reload])


    const handleOpen = (val) => {
        setOpen(true)
        setVal(val)
    }

    return (
        <>
            <PageTitle>D2C Courier Partners Master</PageTitle>
            {(isLoading) && <Loader />}
            <MUIModal open={open} handleClose={() => setOpen(false)} children={
                <KamFields val={val} setOpen={setOpen} />
            }
                title={`Add KAM Details`}
            />
            {/* <MUIModal open={addOpen} handleClose={() => { setAddOpen(false); setIsEditData(null) }} maxWidth='lg' children={
                <AddCourier supported_shipment={'B2C'} setAddOpen={setAddOpen} setReload={setReload} isEditData={isEditData} />
            }
                title={`Add/Update D2C Courier Partner Details`}
            /> */}

            <SideDrawer drawerWidth='70%' title= {isEditData ? 'Edit D2C Courier Partner Details' : 'Add D2C Courier Partner Details'}
                subtitle= {isEditData ? 'Provide details to edit D2C Courier Partner Details' : 'Provide details to add D2C Courier Partner Details'}
                open={addOpen ? true : false}
                setOpen={() => { setAddOpen(false); setIsEditData(null) }}
                children={<AddCourier supported_shipment={'B2C'}
                    setAddOpen={setAddOpen}
                    setReload={setReload} isEditData={isEditData} />}
            >
            </SideDrawer>

            <Card sx={{ mb: 2, boxShadow: '0 1px 3px rgba(0,0,0,0.05)', borderRadius: '8px' }}>
                <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, alignItems: 'flex-end' }}>
                            <FilterField>
                                <FieldLabel>Courier</FieldLabel>
                                <CourierFilter filterList={"B2C"} />
                            </FilterField>
                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flex: '0 0 auto' }}>
                                <LoadingButton
                                    loading={isSubmitting}
                                    variant="contained"
                                    size="small"
                                    type="submit"
                                    sx={{ bgcolor: '#1565c0', color: '#fff', fontSize: '12px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px', px: 2.5, py: 1, '&:hover': { bgcolor: '#0d47a1' } }}
                                >Filter</LoadingButton>
                                <Button variant="contained" size="small"
                                    sx={{ bgcolor: '#ef4444', color: '#fff', fontSize: '12px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px', px: 2.5, py: 1, '&:hover': { bgcolor: '#dc2626' } }}
                                    onClick={() => {
                                        setCourierFilter(null)
                                        setFilter()
                                        reset({
                                            courier: null
                                        })
                                    }}>Reset</Button>
                            </Box>
                            <Box sx={{ flexGrow: 1 }} />
                            <Button
                                variant="contained"
                                size="small"
                                startIcon={<AddIcon />}
                                onClick={() => { setAddOpen(true) }}
                                sx={{ bgcolor: '#1565c0', color: '#fff', fontSize: '12px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px', px: 2.5, py: 1, '&:hover': { bgcolor: '#0d47a1' } }}
                            >
                                Add Courier
                            </Button>
                        </Box>
                    </FormProvider>
                </CardContent>
            </Card>
            <Box sx={{ bgcolor: '#fff', borderRadius: 2, boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
                <ProzoDataGrid
                    columns={Columns}
                    autoHeight={true}
                    rows={courierFilter ? courierFilter : tabList || []}
                    sizePerPage={sizePerPage}
                    setSizePerPage={setSizePerPage}
                    setPage={setPage}
                    page={page}
                    pagination={true}
                    hideFooterPagination={false}
                    getRowHeight={() => 'auto'}
                    rowCount={Number.MAX_VALUE}
                    getRowId={(row) => row.id}
                    sx={gridSx}
                />
            </Box>
        </>
    )
}



const KamFields = ({ val, setOpen }) => {
    const [loading, setLoading] = useState(false)
    const { enqueueSnackbar } = useSnackbar();
    let Designation = designationB2c.map((op) => ({ label: _.startCase(op), value: op }))
    const phoneRegExp = /^\d{10}$/;



    const methods = useForm({
        mode: 'onChange',
        defaultValues: {
            list: [
                {
                    name: "",
                    email: "",
                    contactNumber: "",
                    location: "",
                    designation: "",
                    description: "",
                },
            ],
        },
    });
    const { control, handleSubmit, reset } = methods;


    const { fields, append, remove } = useFieldArray({
        control,
        name: "list",
    });

    const onSubmit = (data) => {
        setLoading(true)
        let payload = {
            ref: val.id,
            type: "COURIER",
            kam: []
        }
        data.list.forEach((item) => {
            payload.kam.push({
                name: item.name,
                location: item.location,
                phone: item.contactNumber,
                email: item.email,
                designation: item.designation,
                description: item.description
            });

        })
        postGeneric(apiConstants.ADD_KAM_DETAILS, payload).then((res) => {
            enqueueSnackbar("Successfully Added", { variant: 'success' })
            setLoading(false)
            setOpen(false)
            reset();
        }).catch((err) => {
            enqueueSnackbar("Some error occurred", { variant: 'error' })
            setLoading(false)
            console.log(err)
            setOpen(false)
        })
    }

    const blankContact = { name: "", email: "", contactNumber: "", location: "", designation: "", description: "" };

    return (
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {fields.map((field, index) => (
                    <Box
                        key={field.id}
                        sx={{
                            border: '1px solid #E2E8F0',
                            borderRadius: '12px',
                            bgcolor: '#FCFDFE',
                            p: 2.5,
                        }}
                    >
                        {/* Contact header */}
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
                                <Box sx={{ width: 26, height: 26, borderRadius: '50%', bgcolor: '#e3f2fd', color: '#1565c0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700 }}>
                                    {index + 1}
                                </Box>
                                <Box sx={{ fontSize: 14, fontWeight: 600, color: '#212B36', fontFamily: 'Poppins, sans-serif' }}>
                                    Contact Person {index + 1}
                                </Box>
                            </Box>
                            {fields.length !== 1 && (
                                <Button
                                    onClick={() => remove(index)}
                                    size="small"
                                    startIcon={<DeleteOutlineIcon fontSize="small" />}
                                    sx={{ textTransform: 'none', fontWeight: 600, color: '#ef4444', '&:hover': { bgcolor: 'rgba(239,68,68,0.08)' } }}
                                >
                                    Remove
                                </Button>
                            )}
                        </Box>

                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <RHFTextField
                                    label="Name *"
                                    name={`list.${index}.name`}
                                    rules={{ required: "Name is required" }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <RHFTextField
                                    label="Email * (comma-separated for multiple)"
                                    name={`list.${index}.email`}
                                    placeholder="email1@example.com, email2@example.com"
                                    rules={{
                                        required: "Email is required",
                                        validate: {
                                            validEmails: (value) => {
                                                if (!value) return true;

                                                const emails = value.split(',').map(email => email.trim());
                                                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                                                const invalidEmails = emails.filter(email => !emailRegex.test(email));

                                                if (invalidEmails.length > 0) {
                                                    return `Invalid email(s): ${invalidEmails.join(', ')}`;
                                                }

                                                return true;
                                            }
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <RHFTextField
                                    label="Contact Number *"
                                    name={`list.${index}.contactNumber`}
                                    rules={{
                                        required: "Phone Number is required",
                                        pattern: {
                                            value: phoneRegExp,
                                            message: "Phone Number must be exactly 10 digits"
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <RHFTextField
                                    label="Location"
                                    name={`list.${index}.location`}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <RHFSelectField
                                    width="100%"
                                    name={`list.${index}.designation`}
                                    label={`Select Designation *`}
                                    options={_.orderBy(Designation, 'designation')}
                                    rules={{ required: "Please select designation" }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <RHFTextField
                                    label="Description"
                                    name={`list.${index}.description`}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                ))}

                <Button
                    onClick={() => append({ ...blankContact })}
                    startIcon={<AddCircleOutlineIcon />}
                    sx={{
                        alignSelf: 'flex-start',
                        textTransform: 'none',
                        fontWeight: 600,
                        color: '#1565c0',
                        border: '1px dashed #90caf9',
                        borderRadius: '10px',
                        px: 2,
                        py: 1,
                        '&:hover': { bgcolor: '#e3f2fd', borderColor: '#1565c0' },
                    }}
                >
                    Add another contact
                </Button>

                {/* Footer actions */}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1.5, pt: 2, borderTop: '1px solid #EEF1F5' }}>
                    <Button
                        onClick={() => reset()}
                        variant="outlined"
                        sx={{ textTransform: 'none', fontWeight: 600, color: '#64748b', borderColor: '#CBD5E1', '&:hover': { borderColor: '#94a3b8', bgcolor: '#f8fafc' } }}
                    >
                        Reset
                    </Button>
                    <LoadingButton
                        loading={loading}
                        type="submit"
                        variant="contained"
                        sx={{ textTransform: 'none', fontWeight: 700, bgcolor: '#1565c0', px: 3, '&:hover': { bgcolor: '#0d47a1' } }}
                    >
                        Save KAM Details
                    </LoadingButton>
                </Box>
            </Box>
        </FormProvider>
    )
}

